import { render, staticRenderFns } from "./idolTechnicalServiceShopFeeList.vue?vue&type=template&id=61190802&scoped=true"
import script from "./idolTechnicalServiceShopFeeList.vue?vue&type=script&lang=ts"
export * from "./idolTechnicalServiceShopFeeList.vue?vue&type=script&lang=ts"
import style0 from "./idolTechnicalServiceShopFeeList.vue?vue&type=style&index=0&id=61190802&prod&lang=stylus&scoped=true"
import style1 from "./idolTechnicalServiceShopFeeList.vue?vue&type=style&index=1&id=61190802&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61190802",
  null
  
)

export default component.exports